import { Box } from '@mui/material';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { routeBarSignal, useRouteBarActive } from './routeBarState';
import { layout } from '@/theme/tokens';
import './routeBar.css';

/**
 * The 3px aqua bar along the foot of the top bar, while a route or a list is
 * on its way (Loaders board). Aqua is the signal colour, and this is a signal:
 * an in-flight bar is aqua, a real fraction would be indigo. It sits over the
 * top bar's own hairline, so it costs no layout and nothing moves when it
 * comes and goes.
 */
export function RouteBar() {
  const { t } = useTranslation();
  const active = useRouteBarActive();
  if (!active) return null;
  return (
    <Box
      role="progressbar"
      aria-label={t('common.loading')}
      data-testid="route-bar"
      sx={{
        position: 'absolute',
        insetInline: 0,
        bottom: -1,
        height: layout.routeBarHeight,
        overflow: 'hidden',
        bgcolor: 'brand.selected',
        pointerEvents: 'none',
      }}
    >
      <Box className="uw-route-bar" sx={{ bgcolor: 'brand.signal' }} />
    </Box>
  );
}

/** Rendered by a Suspense fallback: holds the route bar up while it waits. */
export function RouteBarSignal() {
  useEffect(() => routeBarSignal.hold(), []);
  return null;
}
